export const BAD_REQUEST = 400;
export const SERVER_ERROR = 500;
export const INVALID_TOKEN = 4011;
export const EXPIRED_TOKEN = 4012;
export const AXIOS_NETWORK_ERROR = 'ERR_NETWORK';
export const UNAUTHENTICATED_EMAIL = 601;
